import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { merge } from 'es-toolkit';
import {PreCERCLISService} from '../../services/pre-cerclis.service';
import {BeachesService} from '../../beaches/beaches.service';
import {SolidWasteService} from '../../solid-waste/solid-waste.service';
import {ContactsService} from '../../contacts/contacts.service';
import {TierIIService} from '../../services/tierii.service';
import {BrownfieldsService} from '../../services/brownfields.service';
import {PesticidesService} from '../../services/pesticides.service';
import {FUDSService} from '../../services/fuds.service';
import {UstService} from '../../ust/ust.service';
import {StandbyGeneratorsService} from '../../standby-generators/standby-generators.service';
import {OneStopService} from '../../one-stop/one-stop.service';
import {ERService} from '../../services/er.service';
import {DynamicModalComponent} from '../../../../../shared/src/lib/modals/dynamic-modal/dynamic-modal.component';
import {JsonPipe, NgIf} from '@angular/common';
import {IsEmptyPipe} from '@shared/pipes/is-empty.pipe';

@Component({
    selector: 'app-add-program-modal',
    templateUrl: './add-program-modal.component.html',
    styleUrls: ['./add-program-modal.component.css'],
    imports: [
        NgIf,
        IsEmptyPipe,
        JsonPipe
    ]
})
export class AddProgramModalComponent implements OnInit {
  @Input() site_id: string;

  constructor(private modalService: NgbModal, private activeModal: NgbActiveModal,
              public PreCERCLIS: PreCERCLISService, public Beaches: BeachesService,
              public SolidWaste: SolidWasteService, public TierII: TierIIService,
              public Brownfields: BrownfieldsService, public Pesticides: PesticidesService,
              public FUDS: FUDSService, public UST: UstService, public StandbyGenerators: StandbyGeneratorsService,
              public OneStop: OneStopService, public ER: ERService) {
  }

  ngOnInit(): void {
  }

//   $scope
// .
//   TierII = TierIIService;
//   $scope
// .
//   SolidWaste = SolidWasteService;
//   $scope
// .
//   FUDS = FUDSService;
//   $scope
// .
//   Brownfields = BrownfieldsService;
//   $scope
// .
//   StandbyGenerators = StandbyGeneratorService;
//   $scope
// .
//   UST = USTService;
//   $scope
// .
//   Water = OneStopService;
//   $scope
// .
//   Pesticides = PesticidesService;
//   $scope
// .
//   ER = ERService;

  public open(service) {
    const tempItem = {site: this.site_id};
    const modalInstance = this.modalService.open(DynamicModalComponent);
    modalInstance.componentInstance.item = tempItem;
    modalInstance.componentInstance.meta = service.meta;

    modalInstance.result.then(response => {
      if (response.newItem !== undefined) {
        service.item = response.newItem;
      }
      this.activeModal.close();
    });
  }

  public close() {
    this.activeModal.close();
  }

}
